(function () {
	const defaultSearchText =
		$(".header__search-label").first().text().trim() || "Search";

	const searchModal = () => {
		$(".search-modal-trigger,.search-modal__mask,.search-modal__close")
			.off("click.searchModal")
			.on("click.searchModal", function (e) {
				e.preventDefault();
				if ($(this).hasClass("search-modal-trigger")) {
					openSearchModal(this);
				} else {
					closeSearchModal();
				}
			});

		$("#search-modal .search__input")
			.off("input.searchModal")
			.on("input.searchModal", function () {
				updateSearchState(this.value);
			});

			$("#search-modal")
				.off("click.searchModalProducts")
				.on("click.searchModalProducts", "[data-search-products-scroll]", function () {
					scrollSearchProducts(this);
				});

			$(window)
				.off("resize.searchModalProducts")
				.on("resize.searchModalProducts", scheduleProductScrollerStateUpdate);

		observeSearchResults();
	};

	document.addEventListener(
		"click",
		function (event) {
			const modalOpener = event.target.closest("#search-modal modal-opener[data-modal]");

			if (!modalOpener) {
				return;
			}

			event.preventDefault();

			const quickViewModal = document.querySelector(modalOpener.getAttribute("data-modal"));

			if (quickViewModal && quickViewModal.closest("#search-modal")) {
				document.body.appendChild(quickViewModal);
			}

			if (!quickViewModal) {
				return;
			}

			const closeWhenQuickViewOpens = new MutationObserver(function () {
				if (!quickViewModal.hasAttribute("open")) {
					return;
				}

				closeWhenQuickViewOpens.disconnect();
				closeSearchModal();
			});

			closeWhenQuickViewOpens.observe(quickViewModal, {
				attributeFilter: ["open"],
				attributes: true,
			});
		},
		true,
	);

	$(document).on("keyup.searchModal", function(e) {
		if ($("#search-modal").hasClass("active") && e.key == "Escape") {
			closeSearchModal();
		}
	});
	function openSearchModal(trigger) {
		const $trigger = $(trigger);
		const drawerClose = document.querySelector(".header-mobile__drawer-close");

		if ($trigger.closest(".header-mobile__menu").length && drawerClose) {
			drawerClose.click();
		}

		updateSearchState($("#search-modal").find(".search__input").val());
		$("#search-modal,.search-modal__mask").addClass("active");
		$("html, body").addClass("overflow-hidden");
		$("#search-modal").find(".search__input").focus();
		if (window.syncRewaclubTabForMobileOverlay) {
			window.syncRewaclubTabForMobileOverlay();
			window.setTimeout(window.syncRewaclubTabForMobileOverlay, 200);
			window.setTimeout(window.syncRewaclubTabForMobileOverlay, 600);
			window.setTimeout(window.syncRewaclubTabForMobileOverlay, 1200);
			window.setTimeout(window.syncRewaclubTabForMobileOverlay, 2000);
		}
	}

	function updateSearchState(value) {
		const searchTerm = (value || "").trim();
		$("#search-modal").toggleClass("search-modal--has-query", searchTerm.length > 0);
		$(".header__search-label").text(searchTerm || defaultSearchText);
		syncPredictiveState();
		syncRewaclubTab();
	}

	function syncPredictiveState() {
		const $modal = $("#search-modal");
		const searchTerm = ($modal.find(".search__input").val() || "").trim();
		const hasResults = $modal.find("#predictive-search-results-groups-wrapper").length > 0;
		const hasNoResults = $modal.find(".predictive-search__text").length > 0;

		$modal.toggleClass("search-modal--has-results", searchTerm.length > 0 && hasResults);
		$modal.toggleClass("search-modal--no-results", searchTerm.length > 0 && !hasResults && hasNoResults);
		$modal.toggleClass(
			"search-modal--quick-view-open",
			$modal.find(".quick-add-modal[open]").length > 0,
			);
			updateSearchImageState();
			scheduleProductScrollerStateUpdate();
			syncRewaclubTab();
		}

	function syncRewaclubTab() {
		if (window.syncRewaclubTabForMobileOverlay) {
			window.syncRewaclubTabForMobileOverlay();
		}
	}

	function updateSearchImageState() {
		$("#search-modal .media img").each(function () {
			const image = this;

			if (image.complete) {
				$(image)
					.toggleClass("search-modal__image--loaded", image.naturalWidth > 0)
					.toggleClass("search-modal__image--broken", image.naturalWidth === 0);
				return;
			}

			$(image)
				.off("load.searchModalImage error.searchModalImage")
				.on("load.searchModalImage", function () {
					$(this)
						.addClass("search-modal__image--loaded")
						.removeClass("search-modal__image--broken");
				})
				.on("error.searchModalImage", function () {
					$(this)
						.addClass("search-modal__image--broken")
						.removeClass("search-modal__image--loaded");
				});
		});
	}

	function observeSearchResults() {
		const searchModalElement = document.getElementById("search-modal");

		if (!searchModalElement || searchModalElement.dataset.searchObserverReady) {
			return;
		}

		const observer = new MutationObserver(syncPredictiveState);
		observer.observe(searchModalElement, {
			attributes: true,
			attributeFilter: ["open"],
			childList: true,
			subtree: true,
		});
		searchModalElement.dataset.searchObserverReady = "true";
	}

	function scrollSearchProducts(button) {
		const direction = button.dataset.searchProductsScroll;
		const wrapper = button.closest(".search-products-scroller");
		const scroller = wrapper?.querySelector(".search-products-track");

		if (!scroller) {
			return;
		}

		const firstItem = scroller.querySelector("li");
		const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : 0;
		const computedStyle = window.getComputedStyle(scroller);
		const columnGap = parseFloat(computedStyle.columnGap || computedStyle.gap) || 0;
		const step = itemWidth + columnGap;
		const visibleCount = step ? Math.max(1, Math.floor(scroller.clientWidth / step)) : 1;
		const pageWidth = step ? step * visibleCount : scroller.clientWidth;
		const scrollAmount = direction === "prev" ? -pageWidth : pageWidth;

			scroller.scrollBy({
				left: scrollAmount,
				behavior: "smooth",
			});
			scheduleProductScrollerStateUpdate();
		}

		function scheduleProductScrollerStateUpdate() {
			window.requestAnimationFrame(function () {
				updateProductScrollerState();
				window.setTimeout(updateProductScrollerState, 250);
			});
		}

		function updateProductScrollerState() {
		const scrollers = document.querySelectorAll(
			"#search-modal .search-products-track",
		);

		scrollers.forEach(function (scroller) {
			if (!scroller.dataset.searchModalScrollReady) {
				scroller.addEventListener("scroll", updateProductScrollerState, {
					passive: true,
				});
				scroller.dataset.searchModalScrollReady = "true";
			}

			const wrapper = scroller.closest(".search-products-scroller");

			if (!wrapper) {
				return;
			}

			const firstCard = scroller.querySelector(".card__inner");
			if (firstCard) {
				const cardHeight = firstCard.getBoundingClientRect().height;
				if (cardHeight > 0) {
					wrapper.style.setProperty("--products-arrow-top", cardHeight / 2 + "px");
				}
			}

			const previousButton = wrapper.querySelector("[data-search-products-scroll='prev']");
			const nextButton = wrapper.querySelector("[data-search-products-scroll='next']");

			if (!previousButton || !nextButton) {
				return;
			}

			const maxScrollLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
			const isAtStart = Math.abs(scroller.scrollLeft) <= 4;
			const isAtEnd = scroller.scrollLeft >= maxScrollLeft - 4;

			previousButton.hidden = maxScrollLeft <= 4 || isAtStart;
			nextButton.hidden = maxScrollLeft <= 4 || isAtEnd;
			previousButton.classList.toggle("is-visible", !previousButton.hidden);
			nextButton.classList.toggle("is-visible", !nextButton.hidden);
		});
		}

	function closeSearchModal() {
		$("#search-modal,.search-modal__mask").removeClass("active");
		$("html, body").removeClass("overflow-hidden");
		$(".search-modal-trigger").first().focus();
		syncRewaclubTab();
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
